export const STINT_IS_BEST_EFFORT = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
];
